import styled from 'styled-components';

export const Container = styled.div`
  height: 250px;
  border: ${({ theme }) =>
    theme.configs.loadingScreen.hasBorder ? '1px solid' : 'none'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: normal;
  padding: 0 10px;
`;
export const IconWrapper = styled.div`
  * {
    fill: ${({ theme }) => theme.configs.mainBox.bgColor};
  }
  svg {
    width: 150px;
    height: 150px;
  }
  img {
    max-width: 150px;
    max-height: 150px;
  }
`;
export const Text = styled.p`
  max-width: 100%;
  margin-top: 26px;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  line-height: 18px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;
